import { IUnrevealedCard } from '../../../Models/StateModels';
import Card from '../Card/Card';
import { EmptySlot, FELT_CARD_BACK_CLASS_NAME } from '../FeltMat/feltParts';

const STACKED_EDGE_SHADOWS = [
  '2px 2px 0 rgba(255, 255, 255, 0.55)',
  '4px 4px 0 rgba(255, 255, 255, 0.35)',
];
const DROP_SHADOW = '4px 8px 14px rgba(0, 0, 0, 0.35)';

export default function Deck({ deckCards }: { deckCards: IUnrevealedCard[] }) {
  if (deckCards.length === 0) {
    return (
      <EmptySlot className="h-[calc(84*var(--card-unit))] w-[calc(58*var(--card-unit))]">
        Empty
      </EmptySlot>
    );
  }

  const edgeShadows = STACKED_EDGE_SHADOWS.slice(0, deckCards.length - 1);
  return (
    <div
      className="rounded-[6px]"
      style={{ boxShadow: [...edgeShadows, DROP_SHADOW].join(', ') }}
    >
      <Card card={deckCards[0]} className={FELT_CARD_BACK_CLASS_NAME} />
    </div>
  );
}
